import React, { Fragment } from "react";
import './App.scss'
import Router from "./routes";

const App = () => {
    return(
        <Fragment> 
            <Router/>
        </Fragment>
    )
}

export default App;